import React from "react";
import { CategoryGridCellTemplate } from "themes/application/categories/components";

function CategoryGridCell(props) {
    return <CategoryGridCellTemplate {...props} />;
}

export default CategoryGridCell;
